module.exports = __webpack_public_path__ + "64bb3ce88b9c08945dbf6002347cbb46.png";